import gql from 'graphql-tag';

export const GET_PARTNER_LINK_METRICS = gql`
  query GetPartnerLinkMetrics($partnerLinkId: ID!) {
    partnerLinkMetrics(partnerLinkId: $partnerLinkId)
  }
`;
